<div class="carousel-container-custom">
  <ngb-carousel>
    @for (file of files; track file.fileId; let i = $index) {
    <ng-template ngbSlide>
      <div class="slide-wrapper">

        @if (file.mediaType === 'image' || !file.mediaType) {
        <img class="carousel-img" [src]="file.url" [alt]="'Slide ' + (i + 1)" (click)="openImage(file.url)" />
        }
        @else if (file.mediaType === 'video') {
        <video class="carousel-video" [src]="file.url" controls></video>
        }

        <button class="btn-delete-carousel" (click)="deleteFile($event, file, i)" title="Eliminar archivo"
          *appHideIfNoPermission="'delete:file'">
          <img src="../../../../assets/icons/common/delete.svg" class="icon-del" alt="Eliminar" />
        </button>

      </div>
    </ng-template>
    }
  </ngb-carousel>
</div>